import { useEffect, useState, useCallback } from "react";

import { debugLog } from "../utils/debugLog";

import PlyrVideoPlayer from "./PlyrVideoPlayer";

const GlobalPlayerOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [streamUrl, setStreamUrl] = useState("");
  const [channelName, setChannelName] = useState("");
  const [channelLogo, setChannelLogo] = useState("");

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setStreamUrl("");
    setChannelName("");
    setChannelLogo("");
  }, []);

  useEffect(() => {
    const handlePlayChannel = (event) => {
      const { streamUrl, channelName, channelLogo } = event.detail;

      debugLog("[GlobalPlayer] Playing channel:", channelName, streamUrl);

      if (streamUrl) {
        debugLog("[GlobalPlayer] Setting isOpen to true");
        setStreamUrl(streamUrl);
        setChannelName(channelName || "Live TV");
        setChannelLogo(channelLogo || "");
        setIsOpen(true);
      } else {
        debugLog("[GlobalPlayer] No streamUrl provided");
      }
    };

    window.addEventListener("playChannel", handlePlayChannel);
    debugLog("[GlobalPlayer] Event listener attached");

    return () => {
      window.removeEventListener("playChannel", handlePlayChannel);
    };
  }, []);

  // Handle escape key to close
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, handleClose]);

  debugLog(
    "[GlobalPlayer] Render - isOpen:",
    isOpen,
    "streamUrl:",
    streamUrl ? "set" : "empty"
  );

  if (!isOpen || !streamUrl) {
    return null;
  }

  debugLog("[GlobalPlayer] Rendering player overlay");

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999999,
        background: "rgba(0, 0, 0, 0.95)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 24px",
          background: "rgba(0, 0, 0, 0.8)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          {channelLogo && (
            <img
              alt=""
              src={channelLogo}
              style={{
                width: 40,
                height: 40,
                borderRadius: 6,
                objectFit: "contain",
                background: "rgba(255,255,255,0.1)",
              }}
            />
          )}
          <span style={{ color: "white", fontSize: 18, fontWeight: "600" }}>
            {channelName}
          </span>
        </div>
        <button
          style={{
            background: "rgba(255,255,255,0.1)",
            border: "none",
            borderRadius: "50%",
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "white",
            fontSize: 20,
          }}
          onClick={handleClose}
        >
          ✕
        </button>
      </div>

      {/* Video Player */}
      <div style={{ flex: 1, position: "relative" }}>
        <PlyrVideoPlayer
          autoplay
          muted={false}
          src={streamUrl}
          title={channelName}
          onClose={handleClose}
        />
      </div>
    </div>
  );
};

export default GlobalPlayerOverlay;
